import React, { useCallback, useState } from "react";
import style from "./stylesheets/AdminPage.module.scss";
import Button from "./Button";
import Input from "./Input";
import { getFunctions, httpsCallable } from "firebase/functions";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const AdminPage = () => {
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [token, setToken] = useState("");
    const [tokenInput, setTokenInput] = useState("");
    const [titleInput, setTitleInput] = useState("");
    const [hintInput, setHintInput] = useState("");
    const [imageInput, setImageInput] = useState("");
    const [releaseTimeInput, setReleaseTimeInput] = useState("");
    const [eventEndTimeInput, setEventEndTimeInput] = useState("");
    const [rewardInput, setRewardInput] = useState("0");
    const [isEventStampInput, setIsEventStampInput] = useState(false);
    const functions = getFunctions();

    const addHint = useCallback(async () => {
        setError("");
        setSuccessMessage("");
        if(!hintInput || !releaseTimeInput || !rewardInput || !titleInput) {
            setError("Please fill out hint, drop time, and reward fields");
            return;
        }
        let result;
        try {
            const func = httpsCallable(functions, "addHint");
            result = await func({
                title: titleInput,
                hint: hintInput,
                image: imageInput,
                releaseTime: new Date(releaseTimeInput),
                reward: parseInt(rewardInput),
                adminToken: token,
                isEventStamp: isEventStampInput,
                eventEndTimeInput: isEventStampInput ? new Date(eventEndTimeInput) : null,
            });
        } catch(e) {
            console.error(e);
            setError("Unexpected error")
            return;
        }
        if(!result.data || !result.data.success || !result.data.secretToken) {
            setError("Failed to add hint");
            console.log(result);
            return;
        }
        setSuccessMessage(`${window.location.origin}/discover/${result.data.secretToken}`);
    }, [eventEndTimeInput, functions, hintInput, imageInput, isEventStampInput, releaseTimeInput, rewardInput, titleInput, token]);

    if(!token) return (
        <div id={style.admin_page}>
            <h1>Hint Admin</h1>
            <div className={style.box}>
                <Input
                    placeholder="Admin password"
                    value={tokenInput}
                    type="password"
                    onChange={(e) => setTokenInput(e.target.value)}
                />
                <Button text="Enter" onClick={() => {
                    setToken(tokenInput);
                    setTokenInput("");
                }} />
            </div>
        </div>
    );

    return (
        <div id={style.admin_page}>
            <h1>Hint Administration</h1>
            <div className={style.box}>
                <h2>Add Hint</h2>
                {error && <p id={style.error}>{error}</p>}
                <Input
                    placeholder="Title"
                    value={titleInput}
                    onChange={(e) => setTitleInput(e.target.value)}
                />
                <Input
                    placeholder="Hint"
                    type="textarea"
                    value={hintInput}
                    onChange={(e) => setHintInput(e.target.value)}
                />
                <Input
                    placeholder="Image URL"
                    value={imageInput}
                    onChange={(e) => setImageInput(e.target.value)}
                />
                <Input
                    placeholder="Drop time"
                    type="datetime-local"
                    value={releaseTimeInput}
                    onChange={(e) => setReleaseTimeInput(e.target.value)}
                />
                <Input
                    placeholder="Reward"
                    type="number"
                    value={rewardInput}
                    onChange={(e) => setRewardInput(e.target.value)}
                />
                <label id={style.event_stamp_label}>
                    <input
                        type="checkbox"
                        checked={isEventStampInput}
                        onChange={(e) => setIsEventStampInput(e.target.checked)}
                    />
                    Is Event Stamp?
                </label>
                {
                    isEventStampInput && (
                        <Input
                            placeholder="Event end time"
                            type="datetime-local"
                            value={eventEndTimeInput}
                            onChange={(e) => setEventEndTimeInput(e.target.value)}
                        />
                    )
                }
                <Button text="Add Hint" onClick={addHint} />
                {successMessage && <p id={style.success}>{successMessage}</p>}
            </div>

            <Footer />
        </div>
    );
};

export default AdminPage;
